module.exports = __webpack_public_path__ + "img/file-recruit.b71f2d0a.svg";